import { useMemo, useState } from 'react'
import { usePreloadImages } from '../../../../../utils/image-loading/usePreloadImages'
import { EliteLandingPageRemark } from '../../../EliteLandingPageRemark'
import MFAccordion from '../../../../ui-components/MFAccordion'
import { GROUPED_STATIC_TEXT_ROLE } from '../../../../ui-components/NameValueTableRow'

export const PowerOfRebalancingPointer = () => {
  const [outsideAssetWidth, setOutsideAssetWidth] = useState(0)
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(false)
  const assetRatio = 0.779

  const bgAssetHeight = useMemo(() => {
    return outsideAssetWidth * (assetRatio ?? 1) || 700
  }, [outsideAssetWidth])

  const powerRankTrendsImage = '/images/elite/power_of_rebalancing_pointer.png'

  usePreloadImages([powerRankTrendsImage])

  return (
    <div className='flex gap-4 justify-between'>
      <div className='flex h-10 w-10' aria-hidden='true'>
        <img src='/images/elite/power_of_rebalancing_icon.svg' alt='' />
      </div>
      <div className='flex flex-col flex-1 w-1'>
        <h3
          role={GROUPED_STATIC_TEXT_ROLE}
          aria-label='Power Rebalancing for effortless Portfolio Rebalancing'
          className='text-[16px] text-black font-[700] m-0'
        >
          <span aria-hidden='true'>
            Power Rebalancing{' '}
            <span className='opacity-60 font-[400]'> for effortless Portfolio Rebalancing </span>
          </span>
        </h3>
        <div
          role={GROUPED_STATIC_TEXT_ROLE}
          aria-label='Get a tax-efficient rebalancing plan to maximise your returns while managing risk.'
          className='pt-1 text-[13px] text-[#6A6E6E]'
        >
          <span aria-hidden='true'>
            Get a tax-efficient rebalancing plan to maximise your returns while managing risk.
          </span>
        </div>

        <div className='flex w-full justify-center pt-6 pb-5'>
          <div className='w-full'>
            <div
              ref={(ref) => {
                if (ref && outsideAssetWidth === 0) {
                  setOutsideAssetWidth(ref?.clientWidth ?? 300)
                }
              }}
              style={{ height: bgAssetHeight }}
              className='w-full h-max'
            >
              <img
                src={powerRankTrendsImage}
                className='w-full h-auto'
                alt='Illustration of portfolio rebalancing'
              />
            </div>
          </div>
        </div>

        <div
          role={GROUPED_STATIC_TEXT_ROLE}
          aria-label='You can view the details of your Rebalancing plan in the Elite Insights sections under the Portfolio tab.'
        >
          <div aria-hidden='true'>
            <EliteLandingPageRemark>
              <div>
                You can view the details of your Rebalancing plan in the Elite Insights sections under the Portfolio
                tab.
              </div>
            </EliteLandingPageRemark>
          </div>
        </div>
        <div className='pt-3'>
          <MFAccordion
            isExpanded={isAccordionExpanded}
            onAccordionClick={() => setIsAccordionExpanded(!isAccordionExpanded)}
            title='Also avoid paying a high expense ratio'
            accessibleName='Also avoid paying a high expense ratio, Get a step-by-step plan to switch your Regular funds to Direct, tax-efficiently.'
            accordionHeaderClassName='!px-0'
            middleContent={
              <div className='flex flex-col'>
                <div className='text-[#232323] text-[14px] font-[500]'>Also avoid paying a high expense ratio</div>
                <div className='text-[#6A6E6E] text-[13px] font-[400] mt-1'>
                  Get a step-by-step plan to switch your Regular funds to Direct, tax-efficiently.
                </div>
              </div>
            }
          >
            <img
              src='/images/commission-savings.png'
              className='w-full h-auto'
              alt='Illustration of commission savings from switching to direct funds'
            />
          </MFAccordion>
        </div>
      </div>
    </div>
  )
}
